export const primaryDefaultChartColor = 'hsl(210,100%,40%)';

export const secondaryDefaultChartColor = '#878C92';

export const chartBorderColor = '#FAF9F6';
